export const LISTING_LIB_APP_SETTING_NAMESPACE = 'frameworkListingLib' as const;
